import $ from "jquery";
import config from '../config.json';
import Cookies from 'js-cookie';
const login_url = config.server + config.api_path + '/login'
const logout_url = config.server + config.api_path + '/logout'

class Authenticator {
  authenticate(formState, cb) {
    var {
      user_name,
      password
    } = formState

    var err = null
    $.post({
        url: login_url,
        data: {
          username: user_name,
          password: password
        },
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done((data) => {
        var _err = data.err
        if (_err && _err.ec !== 0) {
          err = _err.em
        }
        if (_err && _err.ec === 0) {
          Cookies.set('usercache', data.ret.user, {expires: 0.5})
        }
      })
      .always(() => {
        if (this.isAuthenticated()) {
          return cb(null)
        }
        return cb(new Error(err))
      })
  }

  isAuthenticated() {
    return Boolean(Cookies.get('usercache'));
  }

  with_session(data, disableJSON) {
    var request_data = Object.assign({}, data)
    if (!disableJSON) {
      request_data = JSON.stringify(request_data)
    }
    return request_data
  }

  signout(cb) {
    $.post({
        url: logout_url,
        data: {},
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        }
      })
      .done((data) => {
        Cookies.set('usercache', '')
      })
      .always(() => {
        if (cb) cb(null)
      })
  }
}

const authenticator = new Authenticator()

export default authenticator



// WEBPACK FOOTER //
// ./src/auth/auth.react.js